export default import.meta.ROLLDOWN_FILE_URL_jnPV4bkeVR3dO1CwxGX1uA